<template>
  <div class="report">
    <div class="report_page1" style="text-align:center;">
      <p class="report_page1_title">高校教学实验室安全工作年度报告</p>
      <p class="report_page1_p">（高等学校）</p>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="学校名称：" prop="school_name">
          <el-input v-model="ruleForm.school_name" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="年度" prop="date">
          <el-date-picker type="year" prefix-icon="el-icon-" value-format="yyyy" format="yyyy 年" placeholder="" v-model="ruleForm.year"></el-date-picker>
        </el-form-item>
        <el-form-item label="学期" prop="term">
          <el-select v-model="ruleForm.term" clearable filterable placeholder="">
            <el-option v-for="(item,index) in $store.state.terms" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教学实验室安全管理职能部门：" prop="department_t">
          <el-input v-model="ruleForm.department_t" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="教学实验室安全管理职能部门负责人：" prop="head">
          <el-input v-model="ruleForm.head" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="教学实验室安全管理职能部门联系人：" prop="link">
          <el-input v-model="ruleForm.link" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="教学实验室安全管理职能部门联系电话：" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="教学实验室安全管理职能部门联系人电子邮箱：" prop="email">
          <el-input v-model="ruleForm.email" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="填报日期" prop="date">
          <el-date-picker type="date" prefix-icon="el-icon-" value-format="yyyy-MM-dd" format="yyyy 年 MM 月 dd 日" placeholder="" v-model="ruleForm.date"></el-date-picker>
        </el-form-item>
        <div class="report_line"></div>
        <div class="report_page2">
          <p class="report_page2_title1">一、教学实验室发展和安全工作基本状况</p>
          <p class="report_page2_title2">（一）教学实验室基本情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td>学校名称</td>
              <td colspan="3">
                <el-input v-model="ruleForm.tableJson.table_1_1.school_name" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>教学实验室安全管理职能部门名称</td>
              <td colspan="3">
                <el-input v-model="ruleForm.tableJson.table_1_1.department" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>教学实验室数量（个）</td>
              <td colspan="3">
                <el-input v-model="ruleForm.tableJson.table_1_1.number" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>教学实验室面积（m2）</td>
              <td colspan="3">
                <el-input v-model="ruleForm.tableJson.table_1_1.area" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td rowspan="2">教学实验室安全工作年度经费投入（万元）</td>
              <td rowspan="2" style="width:60px">
                <el-input v-model="ruleForm.tableJson.table_1_1.funds" placeholder=""></el-input>
              </td>
              <td>其中，专门用于改善安全条件经费投入（万元）</td>
              <td style="width:50px">
                <el-input v-model="ruleForm.tableJson.table_1_1.fundsToSafe" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>其中，专门用于人员安全培训经费投入（万元）</td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_1_1.fundsToTrain" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <p class="report_page2_tips">注：表中所有名称都必须填写全称。</p>
          <p class="report_page2_title2">（二）全校教学实验室安全队伍建设情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td colspan="4">队伍结构建设</td>
            </tr>
            <tr>
              <td>人员配备依据</td>
              <td style="width:270px;">
                <el-checkbox-group v-model="ruleForm.tableJson.table_1_2.yiju">
                  <el-checkbox v-for="check in checkOption" :label="check" :key="check">{{check}}</el-checkbox>
                </el-checkbox-group>
                <el-input type="textarea" :rows="4" v-model="ruleForm.tableJson.table_1_2.yijubuchong" placeholder="选择其他填写"></el-input>
              </td>
              <td>配备情况说明</td>
              <td class="s_t">
                <el-input type="textarea" :rows="10" v-model="ruleForm.tableJson.table_1_2.yijushuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="2">专职人员情况</td>
              <td style="width:70px">数量</td>
              <td style="width:150px">占专职人员总数比例</td>
            </tr>
            <tr>
              <td colspan="2">专职人员总数（人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.zhuanzhizongshu" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.zhuanzhibili" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td rowspan="4">学历情况</td>
              <td>博士研究生人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.boshishu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.boshibili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>硕士研究生人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.shuoshishu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.shuoshibili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>本科生人员数量</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.benkeshu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.benkebili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>其他人员数量</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.qitaxuelishu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.qitaxuelibili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td rowspan="5">职称情况</td>
              <td>正高级人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.zhenggaojishu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.zhenggaojibili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>副高级人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.fugaojishu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.fugaojibili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>中级人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.zhongjishu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.zhongjibili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>初级人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.chujishu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.chujibili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>其他人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.qitazhichenshu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.qitazhichenbili1" placeholder=""></el-input>
              </td>
            </tr>

            <tr>
              <td rowspan="4">岗位情况</td>
              <td>实验岗人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.shiyanshu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.shiyanbili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>教学岗人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.jiaoxueshu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.jiaoxuebili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>科研岗人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.keyanshu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.keyanbili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>其他岗位人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.qitagangweishu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.qitagangweibili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>资质情况</td>
              <td>具有注册安全工程师资质人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.zizhishu1" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.zizhibili1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="2">兼职人员情况</td>
              <td>数量</td>
              <td>占兼职人员总数比例</td>
            </tr>
            <tr>
              <td colspan="2">兼职人员总数（人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.jianzhizongshu" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.jianzhibili" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td rowspan="4">学历情况</td>
              <td>博士研究生人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.boshishu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.boshibili2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>硕士研究生人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.shuoshishu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.shuoshibili2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>本科生人员数量</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.benkeshu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.benkebili2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>其他人员数量</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.qitaxuelishu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.qitaxuelibili2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td rowspan="5">职称情况</td>
              <td>正高级人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.zhenggaojishu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.zhenggaojibili2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>副高级人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.fugaojishu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.fugaojibili2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>中级人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.zhongjishu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.zhongjibili2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>初级人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.chujishu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.chujibili2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>其他人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.qitazhichenshu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.qitazhichenbili2" placeholder=""></el-input>
              </td>
            </tr>

            <tr>
              <td rowspan="4">岗位情况</td>
              <td>实验岗人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.shiyanshu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.shiyanbili2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>教学岗人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.jiaoxueshu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.jiaoxuebili2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>科研岗人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.keyanshu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.keyanbili2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>其他岗位人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.qitagangweishu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.qitagangweibili2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>资质情况</td>
              <td>具有注册安全工程师资质人员数量(人）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_2.zizhishu2" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model.number="ruleForm.tableJson.table_1_2.zizhibili2" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <p class="report_page2_title2">（三）教学实验室安全工作基本情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td rowspan="2" style="width:40px;">年份</td>
              <td rowspan="2" style="width:80px;">事故类型（10字以内）</td>
              <td rowspan="2" style="width:80px;">实验室名称</td>
              <td rowspan="2" style="width:100px;">事故过程</td>
              <td rowspan="2" style="width:80px;">事故日期</td>
              <td colspan="2">人员伤亡情况</td>
              <td rowspan="2" style="width:60px;">经济损失（万元）</td>
              <td rowspan="2" style="width:100px;">事故原因</td>
            </tr>
            <tr>
              <td style="width:30px;">伤（人）</td>
              <td style="width:30px;">亡（人）</td>
            </tr>
            <tr style="position: relative;" v-for="(item,index) in ruleForm.tableJson.table_1_3" :key="index">
              <td>
                <el-date-picker :clearable="false" type="year" value-format="yyyy" v-model="ruleForm.tableJson.table_1_3[index].nianfen"></el-date-picker>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="7" maxlength="10" show-word-limit v-model="ruleForm.tableJson.table_1_3[index].leixin" style="border:none;" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="7" v-model="ruleForm.tableJson.table_1_3[index].mingcheng" style="border:none;" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="7" v-model="ruleForm.tableJson.table_1_3[index].guocheng" style="border:none;" placeholder=""></el-input>
              </td>
              <td>
                <el-date-picker type="date" :clearable="false" value-format="yyyy-MM-dd" format="MM月dd日" placeholder="" v-model="ruleForm.tableJson.table_1_3[index].riqi"></el-date-picker>
              </td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_3[index].shang" placeholder=""></el-input>
              </td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_3[index].wang" placeholder=""></el-input>
              </td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_1_3[index].sunshi" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="7" v-model="ruleForm.tableJson.table_1_3[index].yuanyin" style="border:none;" placeholder=""></el-input>
              </td>
              <div class="report_page2_delete" @click="handleDeleteLine('table_1_3',index)" v-if="index>0" title="删除一条"><i class="el-icon-remove-outline"></i></div>
            </tr>
          </table>
          <div class="report_page2_add" title="添加一条" @click="handleAddLine"><i class="el-icon-circle-plus-outline"></i></div>
          <p class="report_page2_tips">注：事故类型包括火灾性事故、爆炸性事故、毒害性事故、机电伤人性事故、设备损坏性事故，其他等。</p>
          <p class="report_page2_title1">二、教学实验室安全责任体系和运行机制建设情况</p>
          <p class="report_page2_title2">（一）教学实验室安全责任体系建设与运行情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td>要求内容</td>
              <td>是</td>
              <td>否</td>
              <td style="width:260px;">文件名称</td>
            </tr>
            <tr>
              <td>成立实验室安全工作领导小组</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_2_1.shifou1" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_2_1.shifou1" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_2_1.wenjian1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>制定实验室安全工作计划并监督实施</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_2_1.shifou2" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_2_1.shifou2" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_2_1.wenjian2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>基本建立三级联动的教学实验室安全管理责任体系</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_2_1.shifou3" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_2_1.shifou3" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_2_1.wenjian3" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>明确学校分管实验室安全的班子成员和各实验室安全管理人员</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_2_1.shifou4" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_2_1.shifou4" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_2_1.wenjian4" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>安全风险较大的单位配备专职安全管理人员</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_2_1.shifou5" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_2_1.shifou5" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_2_1.wenjian5" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="text-align: left;" class="s_t">
                <p>具体说明：（限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_2_1.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>

          </table>
          <p class="report_page2_title2">（二）教学实验室危险源全生命周期管理情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td>要求内容</td>
              <td>是</td>
              <td>否</td>
              <td style="width:260px;">文件名称</td>
            </tr>
            <tr>
              <td>基本建立教学实验室危险源全生命周期管理机制</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_2_2.shifou1" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_2_2.shifou1" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_2_2.wenjian1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="text-align: left;" class="s_t">
                <p>具体说明：（限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_2_2.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>

          </table>
          <p class="report_page2_title2">（三）教学实验室安全责任体系和运行机制建设相关文件</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td>文件级别</td>
              <td>文号</td>
              <td style="width:260px;">文件名称</td>
              <td>发布日期</td>
            </tr>
            <tr style="position: relative;" v-for="(item,index) in ruleForm.tableJson.table_2_3.wenjian" :key="index">
              <td>
                <el-input v-model="ruleForm.tableJson.table_2_3.wenjian[index].jibie" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_2_3.wenjian[index].wenhao" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_2_3.wenjian[index].mingcheng" placeholder=""></el-input>
              </td>
              <td>
                <el-date-picker type="date" :clearable="false" value-format="yyyy-MM-dd" format="yyyy年MM月dd日" placeholder="" v-model="ruleForm.tableJson.table_2_3.wenjian[index].riqi"></el-date-picker>
              </td>
              <div class="report_page2_delete" style="height: 30px;line-height: 30px;top:2px;" @click="handleDeleteLine1('table_2_3','wenjian',index)" v-if="index>0" title="删除一条"><i class="el-icon-remove-outline"></i></div>
            </tr>
            <tr>
              <td colspan="4" style="text-align: left;" class="s_t">
                <p>具体说明：（需明确文件涵盖的主要内容，限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_2_3.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <div class="report_page2_add" title="添加一条" @click="handleAddLine1"><i class="el-icon-circle-plus-outline"></i></div>
          <p class="report_page2_title1">三、教学实验室安全宣传教育情况</p>
          <p class="report_page2_title2">（一）本年教学实验室安全培训情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td>序号</td>
              <td>安全教育开展内容</td>
              <td>数量</td>
            </tr>
            <tr>
              <td>1</td>
              <td>参加安全培训教职工人数（人次）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_3_1.shu1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>参加安全培训学生人数（人次）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_3_1.shu2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="text-align: left;" class="s_t">
                <p>具体说明：（限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_3_1.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <p class="report_page2_title2">（二）教学实验室安全教育情况</p>
          <p class="report_page2_title3">1.本年教学实验室安全教育课程开展情况</p>
          <table class="report_page2_table" border="1" cellspacing="0" style="margin-bottom: 24px;">
            <tr>
              <td>序号</td>
              <td>安全教育开展内容</td>
              <td>数量</td>
            </tr>
            <tr>
              <td>1</td>
              <td>开设选修课（门）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_3_2_1.shu1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>开设必修课（门）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_3_2_1.shu2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>开发在线课程数量（门）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_3_2_1.shu3" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>开发的在线课程中，慕课数量（门）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_3_2_1.shu4" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td>课程学习人次（人次）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_3_2_1.shu5" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="text-align: left;" class="s_t">
                <p>具体说明：（限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_3_2_1.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <p class="report_page2_title3">2.本学段年实验室安全教育教材等编写出版情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td>序号</td>
              <td>类别</td>
              <td>名称</td>
              <td>出版社</td>
              <td style="width:110px;">出版日期</td>
              <td>ISBN编号</td>
              <td>编者</td>
            </tr>
            <tr style="position: relative;" v-for="(item,index) in ruleForm.tableJson.table_3_2_2" :key="index">
              <td>
                {{ index+1 }}
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_3_2_2[index].leibie" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_3_2_2[index].mingcheng" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_3_2_2[index].chubanshu" placeholder=""></el-input>
              </td>
              <td>
                <el-date-picker v-model="ruleForm.tableJson.table_3_2_2[index].riqi" type="date" :clearable="false" value-format="yyyy-MM-dd" format="yyyy年MM月dd日" placeholder=""></el-date-picker>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_3_2_2[index].bianhao" placeholder=""></el-input>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_3_2_2[index].bianzhe" placeholder=""></el-input>
              </td>
              <div class="report_page2_delete" style="height: 30px;line-height: 30px;top:2px;" @click="handleDeleteLine('table_3_2_2',index)" v-if="index>0" title="删除一条"><i class="el-icon-remove-outline"></i></div>
            </tr>
          </table>
          <div class="report_page2_add" title="添加一条" @click="handleAddLine2"><i class="el-icon-circle-plus-outline"></i></div>
          <p class="report_page2_tips">注：类别包括教材和其他出版物。</p>
          <p class="report_page2_title2">（三）教学实验室安全准入制度建设与运行情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td>序号</td>
              <td>要求内容</td>
              <td>是</td>
              <td>否</td>
              <td style="width:260px;">文件名称</td>
            </tr>
            <tr>
              <td>1</td>
              <td>基本建立教学实验室安全准入制度</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>·是否包括教学新项目/活动申请立项前的风险安全评估</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_3_3.shifou1" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_3_3.shifou1" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_3_3.wenjian1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>·是否包括师生进入实验室前的安全知识、安全技能和操作规范培训与考核</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_3_3.shifou2" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_3_3.shifou2" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_3_3.wenjian2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>·是否包括对高校实验室安全责任体系的各级管理人员，如相关校领导、中层干部、安全职能部门管理人员、专职技术人员、开展实验活动的院系教师等进行培训与考核</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_3_3.shifou3" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_3_3.shifou3" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_3_3.wenjian3" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>建立安全教育网络学习（考试）平台</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_3_3.shifou4" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_3_3.shifou4" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_3_3.wenjian4" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="5" style="text-align: left;" class="s_t">
                <p>具体说明：（限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_3_3.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>

          </table>
          <p class="report_page2_title1">四、教学实验室安全专项检查情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td style="width:7%;">年份</td>
              <td style="width:8%;">组织机构级别</td>
              <td style="width:9%;">组织部门名称</td>
              <td style="width:9%;">安全检查名称</td>
              <td style="width:13%;">检查内容</td>
              <td style="width:10%;">检查日期</td>
              <td style="width:8%;">隐患数量</td>
              <td style="width:14%;">隐患具体内容</td>
              <td style="width:8%;">隐患整改完成数量</td>
              <td style="width:14%;">隐患整改未完成原因</td>
            </tr>
            <tr style="position: relative;" v-for="(item,index) in ruleForm.tableJson.table_4_1.qingkuan" :key="index">
              <td>
                <el-date-picker :clearable="false" type="year" value-format="yyyy" v-model="ruleForm.tableJson.table_4_1.qingkuan[index].nianfen"></el-date-picker>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_4_1.qingkuan[index].jibie" style="border:none;" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_4_1.qingkuan[index].zuzhimingcheng" style="border:none;" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_4_1.qingkuan[index].jianchamingcheng" style="border:none;" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_4_1.qingkuan[index].jianchaneirong" style="border:none;" placeholder=""></el-input>
              </td>
              <td>
                <el-date-picker type="date" v-model="ruleForm.tableJson.table_4_1.qingkuan[index].riqi" :clearable="false" value-format="yyyy-MM-dd" format="MM月dd日" placeholder=""></el-date-picker>
              </td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_4_1.qingkuan[index].yhshuliang" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_4_1.qingkuan[index].yhneirong" style="border:none;" placeholder=""></el-input>
              </td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_4_1.qingkuan[index].yhwcshuliang" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_4_1.qingkuan[index].yuanyin" style="border:none;" placeholder=""></el-input>
              </td>
              <div class="report_page2_delete" @click="handleDeleteLine1('table_4_1','qingkuan',index)" v-if="index>0" title="删除一条"><i class="el-icon-remove-outline"></i></div>
            </tr>
            <tr>
              <td colspan="10" style="text-align: left;" class="s_t">
                <p>具体说明：（限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_4_1.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <div class="report_page2_add" title="添加一条" @click="handleAddLine3"><i class="el-icon-circle-plus-outline"></i></div>
          <p class="report_page2_tips">注：本表只统计教育部/相关部委、省级教育行政部门/有关部门（单位）教育司（局）、学校开展的专项检查。</p>
          <p class="report_page2_title1">五、教学实验室安全应急能力建设情况</p>
          <p class="report_page2_title2">（一）实验室安全应急体系建设情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td>序号</td>
              <td>要求内容</td>
              <td>是</td>
              <td>否</td>
              <td style="width:260px;">文件名称</td>
            </tr>
            <tr>
              <td>1</td>
              <td>建立校级实验室安全应急预案</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_5_1.shifou1" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_5_1.shifou1" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_5_1.wenjian1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>定期培训和实施演练</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_5_1.shifou2" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_5_1.shifou2" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_5_1.wenjian2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>配齐实验防护用品与装备并保证有效</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_5_1.shifou3" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_5_1.shifou3" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_5_1.wenjian3" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>按照国家有关规定立即如实报告，不得瞒报、谎报或迟报，不得故意破坏事故现场、毁灭有关证据</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_5_1.shifou4" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_5_1.shifou4" label="否"></el-radio>
              </td>
              <td>
                <el-input v-model="ruleForm.tableJson.table_5_1.wenjian4" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="5" style="text-align: left;" class="s_t">
                <p>具体说明：（限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_5_1.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <p class="report_page2_title2">（二）本年实验室安全应急能力建设实施情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td>序号</td>
              <td>内容</td>
              <td>数量</td>
            </tr>
            <tr>
              <td>1</td>
              <td>已经完成的应急预案数量（个）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_5_2.shu1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>开展应急演练次数（次）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_5_2.shu2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>参加应急演练人数（人次）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_5_2.shu3" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>实验室专职管理人员接受应急能力培训人次（人次）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_5_2.shu4" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="text-align: left;" class="s_t">
                <p>具体说明：（限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_5_2.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <p class="report_page2_title1">六、教学实验室安全工作信息化建设情况</p>
          <p class="report_page2_title2">（一）教学实验室信息化资源、平台建设情况</p>
          <p class="report_page2_title3">1.信息化资源建设情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td>序号</td>
              <td>内容</td>
              <td>数量</td>
            </tr>
            <tr>
              <td>1</td>
              <td>安全类信息化资源总量（Mb）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_6_1_1.shu1" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>网站年度访问总量（人次）</td>
              <td>
                <el-input type="number" v-model.number="ruleForm.tableJson.table_6_1_1.shu2" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="text-align: left;" class="s_t">
                <p>具体说明：（限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_6_1_1.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <p class="report_page2_title3">2.信息化平台建设情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td>要求内容</td>
              <td>是</td>
              <td>否</td>
            </tr>
            <tr>
              <td>建设全校统一的教学实验室安全管理信息化系统</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_6_1_2.shifou1" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_6_1_2.shifou1" label="否"></el-radio>
              </td>
            </tr>
            <tr>
              <td>建立危险源信息数据登记、记录全流向、闭环化管理与运行机制</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_6_1_2.shifou2" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_6_1_2.shifou2" label="否"></el-radio>
              </td>
            </tr>
            <tr>
              <td>建立安全信息汇总、分析、发布、监督、追踪等综合有效管理体系</td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_6_1_2.shifou3" label="是"></el-radio>
              </td>
              <td>
                <el-radio v-model="ruleForm.tableJson.table_6_1_2.shifou3" label="否"></el-radio>
              </td>
            </tr>
            <tr>
              <td colspan="3" style="text-align: left;" class="s_t">
                <p>具体说明：（限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_6_1_2.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <p class="report_page2_title2">（二）信息技术与安全工作的融合情况</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td style="text-align: left;" class="s_t">
                <p>具体说明：（限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_6_2_1.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <p class="report_page2_title1">七、教学实验室安全工作的典型举措（限报3项）</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td>序号</td>
              <td>举措概况</td>
              <td>实践应用情况</td>
              <td>成效意义</td>
            </tr>
            <tr>
              <td>1</td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_7_1.gaikuang1" style="border:none;" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_7_1.qingkuan1" style="border:none;" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_7_1.yiyi1" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_7_1.gaikuang2" style="border:none;" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_7_1.qingkuan2" style="border:none;" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_7_1.yiyi2" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_7_1.gaikuang3" style="border:none;" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_7_1.qingkuan3" style="border:none;" placeholder=""></el-input>
              </td>
              <td class="s_t">
                <el-input type="textarea" :rows="8" v-model="ruleForm.tableJson.table_7_1.yiyi3" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <p class="report_page2_title1">八、教学实验室安全工作存在的主要问题</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td style="text-align: left;" class="s_t">
                <p>具体说明：（限500字）</p>
                <el-input type="textarea" :rows="12" maxlength="500" show-word-limit v-model="ruleForm.tableJson.table_8_1.shuoming" style="border:none;" placeholder=""></el-input>
              </td>
            </tr>
          </table>
          <p class="report_page2_title1">九、审核意见</p>
          <table class="report_page2_table" border="1" cellspacing="0">
            <tr>
              <td style="text-align: right;" class="s_t">
                <p style="text-align: left;">审核意见：</p>
                <p style="height:600px;"></p>
                <p>数据填报人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <p>数据填报单位负责人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <p>校长签字：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <p>（单位公章）&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <p>年 &nbsp;&nbsp;&nbsp;&nbsp;月 &nbsp;&nbsp;&nbsp;&nbsp; 日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <p style="height:50px;"></p>
              </td>
            </tr>
          </table>
        </div>
        <el-form-item style="margin-top:32px;width:100%;text-align:right;" v-if="type=='add'">
          <el-button @click="handleSave">保存草稿</el-button>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
          <!-- <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateUser)">编辑</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <table>

    </table>
  </div>
</template>

<script>
export default {
  name: 'notice',
  props: ['ruleForm','type'],
  data() {
    return {
      rules: {},
      checkOption: ['岗位职责', '实验室数量', '师生数量', '危险源类别与数量', '其他'],
    };
  },
  created() {},
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    handleSave() {
      this.saveOper();
      this.$message({
        type: 'success',
        center: true,
        message: '保存成功！',
      });
      // this.centerDialogVisible = false;
    },
    saveOper() {
      let obj = JSON.parse(JSON.stringify(this.ruleForm))
      // delete obj.id
      localStorage.setItem('yearReport', JSON.stringify(obj));
    },
    async handleSubmit() {
      // this.saveOper();
      let params = JSON.parse(JSON.stringify(this.ruleForm));
      params.tableJson = JSON.stringify(params.tableJson);
      console.log(JSON.stringify(params));
      let res = await this.$api.instance.interfaceServer('api/annual/report/save', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.$emit('getList');
      }
    },
    handleDeleteLine(table, index) {
      this.ruleForm.tableJson[table].splice(index, 1);
    },
    handleDeleteLine1(key1, key2, index) {
      this.ruleForm.tableJson[key1][key2].splice(index, 1);
    },
    handleAddLine3() {
      this.ruleForm.tableJson.table_4_1.qingkuan.push({
        nianfen: '',
        jibie: '',
        zuzhimingcheng: '',
        jianchamingcheng: '',
        jianchaneirong: '',
        riqi: '',
        yhshuliang: '',
        yhneirong: '',
        yhwcshuliang: '',
        yuanyin: '',
      });
    },
    handleAddLine2() {
      this.ruleForm.tableJson.table_3_2_2.push({
        leibie: '',
        mingcheng: '',
        chubanshu: '',
        riqi: '',
        bianhao: '',
        bianzhe: '',
      });
    },
    handleAddLine1() {
      this.ruleForm.tableJson.table_2_3.wenjian.push({
        jibie: '',
        wenhao: '',
        mingcheng: '',
        riqi: '',
      });
    },
    handleAddLine() {
      this.ruleForm.tableJson.table_1_3.push({
        nianfen: '',
        leixin: '',
        mingcheng: '',
        guocheng: '',
        riqi: '',
        shang: '',
        wang: '',
        sunshi: '',
        yuanyin: '',
      });
    },
    handleZZRatio(val, key, key2) {
      if (!this.ruleForm.tableJson.table_1_2.zhuanzhizongshu) {
        this.$message.warning('请先填写总数！');
        this.this.ruleForm.tableJson.table_1_2.return;
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import '../css/yearReport.less';
</style>
